import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../Components/AdminNavbar";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";



export default function AddBlog() {
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    content: "",
    altText: "",
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    schema: "",
  });
const navigate = useNavigate();
  const [featuredImage, setFeaturedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
  const { name, value } = e.target;

  // If editing the title, auto-generate slug
  if (name === "title") {
    const slug = value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")     // remove invalid chars
      .replace(/\s+/g, "-")             // replace spaces with -
      .replace(/-+/g, "-");             // collapse dashes

    setFormData((prev) => ({
      ...prev,
      title: value,
      slug,
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFeaturedImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const blogData = new FormData();
    blogData.append("title", formData.title);
    blogData.append("slug", formData.slug);
    blogData.append("content", formData.content);
    blogData.append("featured_image", featuredImage);
    blogData.append("alt_text", formData.altText);
    blogData.append("meta_title", formData.metaTitle);
    blogData.append("meta_description", formData.metaDescription);
    blogData.append("meta_keywords", formData.metaKeywords);
    blogData.append("schema", formData.schema);

    const res = await axios.post("https://dropshopi.com/api/add-blog.php", blogData);
    if (res.data.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Blog Added!",
        text: "Your blog has been successfully added.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/all-blog");
      });
    } else {
      Swal.fire("Error", res.data.message || "Blog upload failed.", "error");
    }
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Something went wrong.", "error");
  }

  setLoading(false);
};
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="container py-5 text-white"
      style={{ background: "#121212", minHeight: "100vh" }}
    >


<AdminNavbar/>

      <h2 className="mb-4 text-warning">Add New Blog</h2>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="title"
            className="form-control bg-dark text-white border-secondary"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Slug</label>
          <input
  type="text"
  name="slug"
  className="form-control bg-dark text-white border-secondary"
  value={formData.slug}
  onChange={handleInputChange}
  readOnly
/>
        </div>

        <div className="mb-3">
          <label className="form-label">Content</label>
          <div className="bg-white text-dark rounded">
            <CKEditor
  editor={ClassicEditor}
  config={{
    toolbar: {
      items: [
        "undo",
        "redo",
        "|",
        "heading",
        "|",
        "bold",
        "italic",
        "underline",
        "|",
        "link",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "insertTable",
        "|",
        "sourceEditing"
      ]
    },
    heading: {
      options: [
        { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
        { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
        { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
        { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
        { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
        { model: "heading5", view: "h5", title: "Heading 5", class: "ck-heading_heading5" },
        { model: "heading6", view: "h6", title: "Heading 6", class: "ck-heading_heading6" }
      ]
    },
    removePlugins: [
      "CKBox",
      "CKFinder",
      "EasyImage",
      "RealTimeCollaborativeComments",
      "RealTimeCollaborativeTrackChanges",
      "RealTimeCollaborativeRevisionHistory",
      "PresenceList",
      "Comments",
      "TrackChanges",
      "TrackChangesData",
      "RevisionHistory",
      "Pagination",
      "WProofreader"
    ]
  }}
  onChange={(event, editor) => {
    const data = editor.getData();
    setFormData((prev) => ({
      ...prev,
      content: data
    }));
  }}
/>

          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Featured Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="form-control bg-dark text-white border-secondary"
          />
          {imagePreview && (
            <div className="mt-3">
              <img
                src={imagePreview}
                alt="Preview"
                style={{ width: "100%", maxHeight: 200, objectFit: "cover" }}
              />
            </div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label">Alt Text</label>
          <input
            type="text"
            name="altText"
            className="form-control bg-dark text-white border-secondary"
            value={formData.altText}
            onChange={handleInputChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Meta Title</label>
          <input
            type="text"
            name="metaTitle"
            className="form-control bg-dark text-white border-secondary"
            value={formData.metaTitle}
            onChange={handleInputChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Meta Description</label>
          <textarea
            name="metaDescription"
            rows="2"
            className="form-control bg-dark text-white border-secondary"
            value={formData.metaDescription}
            onChange={handleInputChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Meta Keywords</label>
          <input
            type="text"
            name="metaKeywords"
            className="form-control bg-dark text-white border-secondary"
            value={formData.metaKeywords}
            onChange={handleInputChange}
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Schema (JSON-LD)</label>
          <textarea
            name="schema"
            rows="4"
            className="form-control bg-dark text-white border-secondary"
            placeholder='{"@context": "https://schema.org", "@type": "BlogPosting", ...}'
            value={formData.schema}
            onChange={handleInputChange}
          />
        </div>

        <button
          type="submit"
          className="btn btn-warning w-100 py-2 d-flex justify-content-center align-items-center"
          disabled={loading}
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></span>
          ) : (
            "Submit Blog"
          )}
        </button>
      </form>
    </motion.div>
  );
}
